<template>
  <div>
    <div
      class="notice-container"
      :style="{
        transform: transformStr,
        transitionDuration: disabledSpeed ? '0ms' : moveSpeed
      }"
    >
      <div class="notice-item" v-for="(item, index) in data" :key="index">
        <div class="notice-text">{{ item }}</div>
      </div>
      <div>
        <div
          class="notice-item last-data"
          v-for="(lastitem, lastindex) in lastData"
          :key="lastindex"
        >
          <div class="notice-text">{{ lastitem }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    autoplay: {
      type: Number,
      default: 3000
    },
    speed: {
      type: Number,
      default: 60
    }
  },
  data() {
    return {
      defaultCur: -2,
      cur: -2,
      height: 20,
      margin: 6,
      disabledSpeed: false,
      screenWidth: 375,
      designWidth: 375
    }
  },
  computed: {
    transformStr() {
      let offset = this.cur * (this.height + this.margin)
      offset = (offset * this.screenWidth) / this.designWidth
      return 'translateY(' + -offset + 'px)'
    },
    moveSpeed() {
      let speed = ((this.height + this.margin) / this.speed) * 1000
      return speed + 'ms'
    },
    lastData() {
      return this.data.slice(-2)
    }
  },
  created() {
    this.screenWidth = window.screen.width
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        this.updateTransformStr()
      }, this.autoplay)
    },
    updateTransformStr() {
      if (this.cur == this.data.length) {
        this.disabledSpeed = true
      } else {
        this.disabledSpeed = false
      }
      if (this.cur < this.data.length) {
        this.cur++
      } else {
        this.cur = 0
        setTimeout(() => {
          this.updateTransformStr()
        }, 0)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.notice-container {
  transition-duration: 500ms;

  .notice-item {
    max-width: 100%;
    margin-bottom: 6px;
    height: 20px;
    .notice-text {
      display: inline-block;
      padding: 0px 7px;
      white-space: nowrap;
      height: 20px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      backdrop-filter: blur(6px);
      font-size: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #ffffff;
      line-height: 20px;
    }
  }
}
</style>
